import { motion } from "framer-motion";
import { Chrome, Infinity as InfinityIcon, Star } from "lucide-react";

const BADGES = [
  { icon: Chrome, name: "Google Partner", sub: "Certified Ads Team", testid: "badge-google-partner" },
  { icon: InfinityIcon, name: "Meta Business Partner", sub: "Facebook & Instagram", testid: "badge-meta-partner" },
  { icon: Star, name: "Yelp Advertising Partner", sub: "Local Growth Certified", testid: "badge-yelp-partner" },
];

export const PlatformProof = () => {
  return (
    <section data-testid="platform-proof-strip" className="relative bg-[#060B18] border-y border-amber-500/10 py-14">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center font-mono text-[10px] uppercase tracking-[0.35em] text-slate-500 mb-8"
        >
          Certified & Verified Where It Matters
        </motion.p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-10">
          {BADGES.map((b, i) => (
            <motion.div
              key={b.name}
              data-testid={b.testid}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="group flex items-center gap-4 border border-amber-500/20 bg-[#0A1128]/60 px-7 py-4 hover:border-amber-400/50 transition-colors duration-500"
            >
              <b.icon size={26} strokeWidth={1.25} className="text-amber-400/90 transition-transform duration-500 group-hover:scale-110" />
              <div className="leading-tight">
                <p className="font-serif text-lg font-semibold text-amber-50">{b.name}</p>
                <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-slate-400">{b.sub}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
